import React, { Fragment, useContext, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Badge from '@material-ui/core/Badge';
import ButtonBase from '@material-ui/core/ButtonBase';

import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { getIsShowCalendarMoreTileBatch } from '../../common/calendarHelper';

import AfitdTypography from '../../common/elemental/AfitdTypography';
import InterviewListPopover from './InterviewListPopover';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

// import cx from 'clsx';
import { format } from 'date-fns';
// import _get from 'lodash/get';

const styles = theme => ({
    root: {
        minHeight: '28px',
        margin: '0px 2px 4px 2px',
        padding: '8px', //'6px',
        borderRadius: '10px',
        backgroundColor: '#F7F7FA',
        '&:hover': {
            backgroundColor: 'rgba(125, 46, 2, 0.1)',
        },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    interviewContainer: { width: '100%', display: 'flex', justifyContent: 'center' },
    badge: { width: '100%' },
    moreContainer: { flexGrow: 1 },
});

const getDefns = params => {
    const { props, dt, dayId, interviewListPopoverOpen, interviewList, isShowBatch, interviewListPopoverAnchorEl, smMatches } = params;
    const { setInterviewListPopoverOpen, setSelectedDate, setInterviewListPopoverAnchorEl } = params;
    const { remainingCount, classes } = props;

    const interviewListPopoverDayOfWeek = format(dt, 'E');
    const interviewListPopoverDayOfMonth = format(dt, 'd');

    let defns = {
        root: {
            onClick: handleClickMoreInterviewsBlock.bind(null, setInterviewListPopoverAnchorEl, setInterviewListPopoverOpen, setSelectedDate),
        },
        moreText: {
            variant: 'body2',
            clsLightBold: true,
            value: smMatches ? `+${remainingCount}` : `+${remainingCount} interview${remainingCount > 1 ? 's' : ''}`,
            // value: `+${remainingCount} interview${remainingCount > 1 ? 's' : ''}`,
        },
        interviewListPopover: {
            anchorEl: interviewListPopoverAnchorEl,
            open: interviewListPopoverOpen,
            dayId: dayId,
            interviewList,
            dayOfWeek: interviewListPopoverDayOfWeek,
            dayOfMonth: interviewListPopoverDayOfMonth,
            setInterviewListPopoverOpen,
            onClose: handleCloseInterviewListPopover.bind(null, setInterviewListPopoverOpen),
        },
        badge: {
            color: 'primary',
            badgeContent: ' ',
            variant: 'dot',
            invisible: !isShowBatch,
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

// const handleClickMoreInterviewsBlock = (dt, dayId, setInterviewListPopoverInfo, setSelectedDate, evt) => {
const handleClickMoreInterviewsBlock = (setInterviewListPopoverAnchorEl, setInterviewListPopoverOpen, setSelectedDate, evt) => {
    evt.preventDefault();
    setInterviewListPopoverAnchorEl(evt.target);
    setInterviewListPopoverOpen(true);
    setSelectedDate();
};

const handleCloseInterviewListPopover = setInterviewListPopoverOpen => {
    setInterviewListPopoverOpen(false);
};

const MoreInterviewsBlock = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    const context = useContext(LayoutContext);
    const { setSelectedDate, dashboardData } = context;
    const theme = useTheme();
    const smMatches = useMediaQuery(theme.breakpoints.down('sm'));
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    const [interviewListPopoverAnchorEl, setInterviewListPopoverAnchorEl] = useState({});
    const [interviewListPopoverInfo, setInterviewListPopoverInfo] = useState({});
    const [interviewListPopoverOpen, setInterviewListPopoverOpen] = useState(false);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    const { isHidden, interviewList, dt, dayId } = props;
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------
    const isShowBatch = getIsShowCalendarMoreTileBatch({ interviewList, dashboardData });

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Defns
    const defns = getDefns({
        props,
        dt,
        dayId,
        interviewListPopoverInfo,
        setInterviewListPopoverInfo,
        interviewListPopoverOpen,
        setInterviewListPopoverOpen,
        interviewListPopoverAnchorEl,
        setInterviewListPopoverAnchorEl,
        setSelectedDate,
        interviewList,
        isShowBatch,
        smMatches,
    });
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Render
    return isHidden ? null : (
        <Fragment>
            <ButtonBase {...defns.root}>
                <div {...defns.interviewContainer}>
                    <Badge {...defns.badge}>
                        <div {...defns.moreContainer}>
                            <AfitdTypography {...defns.moreText} />
                        </div>
                    </Badge>
                </div>
            </ButtonBase>
            {interviewListPopoverOpen && <InterviewListPopover {...defns.interviewListPopover} />}
        </Fragment>
    );
    //---------------------------------------------------------------------
};

export default withStyles(styles)(MoreInterviewsBlock);
